@use "foundation/colors";

.error-message {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  width: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: colors.$primary-white;
  margin-top: .5em;
  margin-bottom: .5em;
  padding: 8px 12px;
  background-color: rgba(colors.$primary-white, 0.16);
  border: 2px solid colors.$primary-white;
  border-radius: 8px;

  svg {
    min-height: 16px;
    min-width: 16px;
    flex-shrink: 0;
  }
}

.error-icon {
  display: flex;
  background-color: colors.$primary-white;
  border: 2px solid colors.$primary-white;
  border-radius: 50%;

  svg {
    width: 16px;
    height: 16px;
  }

  svg path {
    fill: colors.$secondary-tomato;
    fill-rule: evenodd;
  }
}

.error-message-on-light {
  color: colors.$secondary-tomato;
  background-color: rgba(colors.$secondary-tomato, 0.08);
  border-color: colors.$secondary-tomato;
}

.error-message-on-light .error-icon {
  background-color: colors.$secondary-tomato;
  border-color: colors.$secondary-tomato;

  svg path {
    fill: colors.$primary-white;
  }
}
